import { connect } from "react-redux";
import { get } from "lodash";
import Attachments from "buyer_portal/components/attachment/Attachments";
import { getPageTitle } from "shared/selectors/unit";

const mapStateToProps = (state, props) => {
  const { id } = props.params;
  const { i18n, pageContent } = state;

  return {
    id,
    i18n,
    pageContent,
    account: get(state, "account.account"),
    pageTitle: getPageTitle(state, props)
  };
};

export default connect(mapStateToProps)(Attachments);
